import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    id: null,
    name: 'Usuário',
    email: 'example@email.com',
    first_login: false,
    image: [],
    print_by_default: false,
    atv_notification: false,
    notification: [],
    ntf_antecipacao_carregamento: 0,
    ntf_antecipacao_comissao: 0,
    ntf_antecipacao_agendamento: 0,
}

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
        onUserRegister: (state) => {
            state.first_login = true;
        },
        onUserAuthenticated: (state, action) => {
            if(state.first_login){
                state.first_login = false;
            }
            Object.keys(state).forEach(key => {
                state[key] = action.payload[key] ?? state[key]
            })
        },
        onUserLogOut: (state) => {
            Object.keys(initialState).forEach(key => {
                state[key] = initialState[key];
            })
        },
	},
})

export const { 
    onUserRegister,
    onUserAuthenticated,
    onUserLogOut,
} = userSlice.actions

export default userSlice.reducer